import type { CmsProps } from '../../../types/cms'
import styled from '@emotion/styled'

export const DemoVideoContainer = styled.section<CmsProps>`
  background-color: ${({ backgroundColour }) => backgroundColour ?? '#FFF'};
  padding: 5rem 0 1rem 0;
`

export const DemoVideoFrame = styled.div`
  padding-top: 56.25%;
  position: relative;
`

export const DemoVideoElement = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
`
